import { FC } from 'react'
import { useT } from '../../../../../../../_metronic/i18n/Metronici18n'
import { SolicitacaoExameImagem } from '../../../../atendimento/core/_models'
import { rotuloSituacao } from './situacaoPedido'

type Props = {
  solicitacao: Pick<SolicitacaoExameImagem, 'situacao' | 'motivoCancelamento'>
}

export const SituacaoPedidoBadge: FC<Props> = ({ solicitacao }) => {
  const { t } = useT()
  const { chave, tom, icone } = rotuloSituacao(solicitacao)
  return (
    <span className={`atd-badge atd-badge-${tom}`}>
      <i className={`${icone} fs-8`} style={{ color: 'inherit' }} aria-hidden='true' />
      {t(chave)}
    </span>
  )
}
